import {
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';

export let formSchool = {
    _id: new FormControl(''),
    logo: new FormControl(''),
    name: new FormControl('', [
        Validators.required,
        Validators.maxLength(50)
        // custom function to name already exists
    ]),
    description: new FormControl('', [
        Validators.minLength(0),
        Validators.maxLength(150)
    ]),
    contact: new FormGroup({
        phone: new FormControl('', [
            Validators.pattern('^[+]*[0-9]{8,14}')
        ]),
        email: new FormControl('', [
            //Validators.pattern('^([A-Za-z0-9_\.-]+)@([\dA-Za-z\.-]+)\.([A-Za-z\.]{2,6})$')
            Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')
        ]),
        url: new FormControl('', [
            //Validators.pattern('^(https?\:\/\/)?([\dA-Za-z\.-]+)\.([A-Za-z\.]{2,6})([\/\w \.-]*)*\/?$')
            Validators.pattern('^(http[s]?\://)?(www.|[a-zA-Z].)[a-zA-Z0-9\-\.]+\.(com|edu|gov|mil|net|org|biz|info|name|museum|us|ca|uk|in|jp|ac|ad|ae|af|ag|ai|al|am|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cu|cv|cw|cx|cy |cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sk|sl|sm|sn|so|sr|ss|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt)(\:[0-9]+)*(/($|[a-zA-Z0-9\.\,\;\?\'\\\+&%\$#\=~_\-]+))*$')
        ]),
        address: new FormControl('', [
            Validators.maxLength(500),
            Validators.required
        ]),
        city: new FormControl('', [
            Validators.required
        ]),
        coordinates: new FormGroup({
            long: new FormControl(),
            lat: new FormControl()
        })
    }),
    region: new FormControl('', [

    ]),
     country: new FormControl('', [
        // Validators.required
    ]),
    category: new FormControl('', [
        Validators.required
    ]),
    project_id: new FormControl(''),
    code: new FormControl(''),
    token: new FormControl(''),
    admins: new FormControl(''),
    admin: new FormControl(''),
    active: new FormControl('')
};

export let formUser = {
    logo: new FormControl(),
    first_name: new FormControl('', [
        Validators.required,
        Validators.maxLength(20)
        // custom function to name already exists
    ]),
    last_name: new FormControl('', [
        Validators.required,
        Validators.maxLength(20)
        // custom function to name already exists
    ]),
    partner: new FormControl(''), // for project/content admin
    date_of_birth: new FormControl(''), // for student
    roll: new FormControl(''), // for student
    gender: new FormControl('', [Validators.required]),
    contact: new FormGroup({
        email: new FormControl('', [
            Validators.required,
            //Validators.pattern('^([A-Za-z0-9_\.-]+)@([\dA-Za-z\.-]+)\.([A-Za-z\.]{2,6})$')
            Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')
        ]),
        phone: new FormControl('')
    }),
    address: new FormGroup({
        addr1: new FormControl(''),
        addr2: new FormControl(''),
        code: new FormControl('')
    }),
    project_id: new FormControl(''), // internal
    school_id: new FormControl(''), // internal
    role: new FormControl(''), // internal
    username: new FormControl(''),
    password: new FormControl(''),
    grade: new FormControl(''), // for student
    class: new FormControl('') // for student
};
// end

